import script from "./SidebarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarComponent.vue?vue&type=style&index=0&id=61c37f32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c37f32"]])

export default __exports__